import store from '@/stores/'
import UNIQUE from '@/common/unique'

const defaultValue = {
  list: 'check list',
  item: 'check item'
}
const langValue = function (targetVal) {
  const obj = Object.assign({}, store.state.setting.lang.langValue)
  Object.keys(obj).forEach(function (x) {
    obj[x] = defaultValue[targetVal]
  })
  return obj
}
const defaultItem = function () {
  const objData = {
    label: langValue('item'),
    value: defaultValue.item,
    price: 0
  }
  return Object.assign({}, objData)
}

export default {
  id: 'checkbox',
  name: 'checkbox',
  type: 'action',
  moduleName: 'editor_module_checkbox',
  dataSet: {
    mods: 'checkbox',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'checkbox',
        value: {}
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'text',
        'padding'
      ]
    },
    action: {
      name: 'checkbox',
      isRequired: true,
      label: langValue('list'),
      labelValue: defaultValue.list,
      itemDefault: defaultItem(),
      item: [
        defaultItem()
      ],
      optionQuantity: false,
      min: 1,
      max: 3,
      labelFontSize: 'default',
      valueFontSize: 'default'
    },
    detail: null
  }
}
